export default __webpack_public_path__ + "f50cf0c900ed97ba077f3156a7463e40.svg";